import React, { useRef } from 'react';
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import cargandoCard from "../../components/cargando-card";
import { obtenerDetalleRespuestaChecklistExterno, obtenerExternalInfoChecklist, obtenerFormularioChecklistExterno, obtenerFormularioPieDePaginaExterno, } from "../../api/api-checklist";
import DropdownExportarDetalleChecklist from '../../components/dropdown-exportar-detalle-checklist';
import * as XLSX from 'xlsx-js-style';
import moment from 'moment';
import ComponentDetalleChecklist from '../../components/component-detalle-checklist';
import { obtenerImagenDefaultEmpresaExterno } from '../../api/imagen-empresa';
import { obtenerInfoEmpresaExterno } from '../../api/gestion-dts/api-rastreo-v4';
import shortid from 'shortid';
import { useTranslation } from "react-i18next";
import html2pdf from 'html2pdf.js';

export default function RespuestasChecklistExternoPage() {
    const reportTemplateRef = useRef(null);
    // const history = useHistory();
    const { id, idEmpresa } = useParams();
    const { t } = useTranslation();
    const [cargandoPage, setCargandoPage] = useState(true);
    const [dataChecklist, setDataChecklist] = useState(null);
    const [detalleChecklist, setDetalleChecklist] = useState([]);

    const [infoEmpresa, setInfoEmpresa] = useState("");
    const [urlImagen, setUrlImagen] = useState(null);

    const [infoFormulario, setInfoFormulario] = useState(null);

    const [infoFormularioPiePagina, setInfoFormularioPiePagina] = useState(null);

    const [nombreChecklist, setNombreChecklist] = useState("");

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            let objEnviar = {};
            // console.log('id', id);
            // console.log('idEmpresa', idEmpresa);
            objEnviar.id = id;
            objEnviar.idRespuestaChecklist = id;
            objEnviar.idEmpresa = idEmpresa;
            const externalInfo = await obtenerExternalInfoChecklist(objEnviar);
            // console.log('externalInfo', externalInfo);
            objEnviar.idTipoChecklist = externalInfo.idTipoChecklist;
            objEnviar.idChecklist = externalInfo.idChecklist;
            const detalle = await obtenerDetalleRespuestaChecklistExterno(objEnviar);
            // console.log('detalle', detalle);
            setDataChecklist({
                fechaActualChecklist: externalInfo.fechaActualChecklist,
                nombreChecklist: externalInfo.nombreChecklist,
                labelVehiculo: externalInfo.labelVehiculo,
                fechaRegistro: externalInfo.fechaRegistro,
            });
            setNombreChecklist(externalInfo.nombreChecklist);

            const info = await obtenerInfoEmpresaExterno(objEnviar);
            // console.log('info', info);
            setInfoEmpresa(info);

            const url = await obtenerImagenDefaultEmpresaExterno(objEnviar);
            // console.log('urlImagen', url);
            setUrlImagen(url);

            setDetalleChecklist(detalle);

            const responseFormularioChecklist = await obtenerFormularioChecklistExterno(objEnviar);
            // console.log('formularioChecklist', formularioChecklist);
            if (responseFormularioChecklist.error === false) {
                setInfoFormulario(responseFormularioChecklist.body);
            }

            const formularioPieDePagina = await obtenerFormularioPieDePaginaExterno(objEnviar);
            // console.log('formularioPieDePagina', formularioPieDePagina);
            setInfoFormularioPiePagina(formularioPieDePagina);

            setCargandoPage(false);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
            setCargandoPage(false);
        }
    };

    const renderdetalleChecklist = () => {
        // console.log('renderdetalleChecklist');
        // console.log(detalleChecklist);
        if (detalleChecklist.length > 0) {
            return (
                <div
                    key={shortid.generate()}
                >
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start' }}>
                        {urlImagen !== null &&
                            <img
                                src={urlImagen}
                                alt="Log Empresa"
                                className='img'
                                style={{
                                    maxWidth: '200px',
                                }}
                            />
                        }
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}>
                            {infoEmpresa}
                        </div>
                        <div style={{
                        }}>
                            <p>{moment(dataChecklist.fechaActualChecklist).isValid() === true ? moment(dataChecklist.fechaActualChecklist).format('YYYY/MM/DD') : ""}</p>
                            <p style={{ fontSize: "20px", fontWeight: "bold" }}>
                                {dataChecklist.nombreChecklist}
                            </p>
                            <p>{dataChecklist.labelVehiculo}</p>
                            <p>{t("label_codigo")}: {dataChecklist.fechaRegistro}</p>
                        </div>
                    </div>
                    <ComponentDetalleChecklist
                        key={shortid.generate()}
                        detalleChecklist={detalleChecklist}
                        infoFormulario={infoFormulario}
                        showFooter={true}
                        formularioPieDePagina={infoFormularioPiePagina}
                    />
                </div>
            );
        }
        return null;
    };

    const exportToExcel = async () => {
        try {
            const wb = XLSX.utils.book_new();

            // Static data
            let infoFormularioData = [];
            if (infoFormulario !== null) {
                infoFormularioData = infoFormulario.map(({ label, value }) => ({
                    Pregunta: label,
                    Respuesta: value
                }));
            }

            // Convert static data into worksheet format
            const staticWorksheet = XLSX.utils.json_to_sheet(infoFormularioData, { header: [t("header_pregunta"), t("header_respuesta")] });
            staticWorksheet['!cols'] = [
                { wch: 40 },
                { wch: 60 },
                { wch: 40 },
                { wch: 40 },
            ];
            // Make cell bold
            // const ws = XLSX.utils.json_to_sheet(staticWorksheet);
            staticWorksheet["A1"].s = {
                font: {
                    bold: true,
                }
            };
            staticWorksheet["B1"].s = {
                font: {
                    bold: true,
                }
            };
            // Dynamic data
            const dynamicData = detalleChecklist;
            // Flatten dynamic data
            const dynamicWorksheetData = dynamicData.flatMap((section) =>
                section.preguntas.map((question) => ({
                    Seccion: section.nombreSeccion,
                    Pregunta: question.labelPregunta,
                    OpcionRespuesta: question.labelOpcionRespuesta,
                    Critico: question.critico ? t('label_si') : t('label_no')
                }))
            );

            // Convert dynamic data into worksheet format
            // const dynamicWorksheet = XLSX.utils.json_to_sheet(dynamicWorksheetData, { skipHeader: true });

            // console.log("infoFormularioData", infoFormularioData);
            const index = infoFormularioData.length + 3;

            // Merge the static data and dynamic data into the same sheet
            // First, copy the static data to the sheet
            XLSX.utils.book_append_sheet(wb, staticWorksheet, 'Checklist Data');

            // Now append dynamic data starting right below the static data
            const lastRow = infoFormularioData.length + 2; // Leave a row empty between static and dynamic data
            const range = XLSX.utils.decode_range(staticWorksheet['!ref']);
            range.s.r = lastRow; // Set the starting row for dynamic data
            staticWorksheet['!ref'] = XLSX.utils.encode_range(range); // Update sheet reference

            // Add dynamic data below static data
            XLSX.utils.sheet_add_json(staticWorksheet, dynamicWorksheetData, { origin: `A${lastRow + 1}` });

            // Make header cells bold for dynamic data
            staticWorksheet["A" + index].s = { font: { bold: true } };
            staticWorksheet["B" + index].s = { font: { bold: true } };
            staticWorksheet["C" + index].s = { font: { bold: true } };
            staticWorksheet["D" + index].s = { font: { bold: true } };

            // Write the workbook to a file
            XLSX.writeFile(wb, 'checklist_data.xlsx');
        } catch (err) {
            console.error('exportToExcel error:', err);
        }
    };

    const exportToPdf = () => {
        try {
            const content = reportTemplateRef.current;
            if (!content) return;
            const options = {
                filename: `${nombreChecklist}.pdf`,
                margin: 10,
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    allowTaint: false,
                    logging: false,
                },
                jsPDF: {
                    unit: 'mm',
                    format: 'letter',
                    orientation: 'portrait',
                },
            };
            html2pdf().set(options).from(content).save();
        } catch (err) {
            console.error('exportToPdf error:', err);
        }
    };

    const render = () => {
        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            return (
                <div className="m-4">
                    <div className="pt-1 pb-1 pr-2 flex justify-between items-center">
                        <label className="font-bold">
                            {t('titulo_respuestas_checklist')}
                        </label>
                        <div className='flex items-center'>
                            <DropdownExportarDetalleChecklist
                                exportToExcel={exportToExcel}
                                exportToPdf={exportToPdf}
                            />
                        </div>
                    </div>
                    <hr />
                    <div
                        style={{
                            width: '90%'
                        }}
                    >
                    </div>
                    <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12"
                        ref={reportTemplateRef} id="reportTemplateRef">

                        {renderdetalleChecklist()}

                    </div>
                </div >
            );
        } catch (err) {
            console.log('render err DetalleChecklist');
            console.log(err);
            return (
                <div className="m-8" >
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    }


    return render();
};